import { FC, ReactNode, CSSProperties } from "react";
import { StyledButton, StyledLoadingButton } from "styles/components/buttons";

interface ButtonProps {
  type?: "button" | "submit" | "reset";
  children: ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
  underlined?: boolean;
  color?: string;
  bgColor?: string;
  variant?: "primary" | "secondary" | "white" | "grey" | "text";
  size?: "xs" | "sm" | "md" | "lg";
  loadingPosition?: "start" | "end" | "center";
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  maxWidth?: string;
  dataTestId?: string;
  className?: string;
  style?: CSSProperties; // Add style prop
  fullWidth?: boolean;

  onClick?: () => void;
}

const Button: FC<ButtonProps> = ({
  children,
  type = "button",
  isLoading,
  disabled,
  variant,
  size = "lg",
  underlined,
  loadingPosition = "center",
  color,
  bgColor,
  startIcon,
  endIcon,
  onClick,
  maxWidth,
  dataTestId,
  fullWidth = false,
  className,
  style, // Destructure style prop
}) => {
  return isLoading ? (
    <StyledLoadingButton
      type={type}
      $variant={variant}
      $size={size}
      $color={color}
      $bgColor={bgColor}
      underlined={underlined}
      maxWidth={maxWidth}
      disabled={disabled || isLoading}
      loading={isLoading}
      className={className}
      loadingPosition={loadingPosition}
      data-testid={dataTestId && `${dataTestId}-loading`}
      onClick={onClick}
      style={style} // Apply style prop
      fullWidth={fullWidth}
    />
  ) : (
    <StyledButton
      type={type}
      $variant={variant}
      $size={size}
      $color={color}
      $bgColor={bgColor}
      underlined={underlined}
      maxWidth={maxWidth}
      disabled={disabled || isLoading}
      startIcon={startIcon}
      endIcon={endIcon}
      className={className}
      data-testid={dataTestId}
      onClick={onClick}
      style={style} // Apply style prop
      fullWidth={fullWidth}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
